import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { toSystemDefinedObject } from './system-defined-object.js';
import { StudyEntityType } from './study-entity-type.js';
export function toStudyDesign(studyDesign) {
    checkDefined(studyDesign.studyPopulationId, 'StudyDesign', 'studyPopulationId');
    checkDefined(studyDesign.epochConfigurationId, 'StudyDesign', 'epochConfigurationId');
    return {
        ...toBaseStudyEntity(studyDesign, StudyEntityType.StudyDesign),
        studyPopulationId: studyDesign.studyPopulationId,
        epochConfigurationId: studyDesign.epochConfigurationId,
        participantBlinded: studyDesign.participantBlinded,
        dataCollectorBlinded: studyDesign.dataCollectorBlinded,
        investigatorBlinded: studyDesign.investigatorBlinded,
        outcomesAssessorBlinded: studyDesign.outcomesAssessorBlinded,
        blindingSchema: toSystemDefinedObject(studyDesign.blindingSchema),
    };
}
//# sourceMappingURL=study-design.js.map